import { ReferentialKey } from 'api/referential';
import { ComponentKey } from 'enums/componentKey';
import { addressInputsConfig } from 'features/new-actor/form/inputs-config/addressInputsConfig';
import { InputsConfig } from 'types/form/inputsConfig';
import { IncomesFormFieldNames, TenantFormFieldNames } from '../types/tenantFormFieldNames';
import { TenantGuarantorFormValues } from '../types/tenantGuarantorFormValues';

export const tenantGuarantorInputsConfig: InputsConfig<Exclude<keyof TenantGuarantorFormValues, 'id'>> = {
  [TenantFormFieldNames.Civility]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.Civility,
    name: TenantFormFieldNames.Civility,
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.CIVILITY',
  },
  [TenantFormFieldNames.FirstName]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.FirstName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.FIRST_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.FIRST_NAME'
  },
  [TenantFormFieldNames.LastName]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.LastName,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.LAST_NAME',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.LAST_NAME'
  },
  [TenantFormFieldNames.BirthDate]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.BirthDate,
    type: 'date',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.DATE_OF_BIRTH',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.DATE_OF_BIRTH'
  },
  [TenantFormFieldNames.Phone]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.Phone,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.PHONE',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.PHONE',
  },
  [TenantFormFieldNames.Email]: {
    componentKey: ComponentKey.InputText,
    name: TenantFormFieldNames.Email,
    type: 'text',
    required: true,
    label: 'ACTOR_FORM.PERSONAL_INFOS.LABELS.EMAIL',
    placeholder: 'ACTOR_FORM.PERSONAL_INFOS.PLACEHOLDERS.EMAIL',
  },
  [TenantFormFieldNames.ProfessionalSituation]: {
    componentKey: ComponentKey.ReferentialDropdown,
    referentialKey: ReferentialKey.EmploymentStatus,
    name: TenantFormFieldNames.ProfessionalSituation,
    required: true,
    label: 'TENANT.LABELS.PROFESSIONNAL_STATUS',
    placeholder: 'TENANT.PLACEHOLDERS.PROFESSIONNAL_STATUS',
  },
  [TenantFormFieldNames.Incomes]: {
    componentKey: ComponentKey.DynamicArray,
    name: TenantFormFieldNames.Incomes,
    required: false,
    gridCols: 6,
    fields: [
      {
        componentKey: ComponentKey.ReferentialDropdown,
        name: IncomesFormFieldNames.IncomeType,
        placeholder: "TENANT.LABELS.INCOME_TYPE",
        referentialKey: ReferentialKey.IncomeType,
        colSpan: 4,
        required: true
      },
      {
        componentKey: ComponentKey.InputWithUnit,
        name: IncomesFormFieldNames.Amount,
        type: 'number' as const,
        placeholder: 'COMMON.LABELS.AMOUNT',
        colSpan: 2,
        unit: '€',
        required: true
      },
    ],
    minItems: 0,
    emptyConfig: {
      title: 'TENANT.LABELS.EMPTY_INCOME_TITLE',
      description: 'TENANT.LABELS.EMPTY_INCOME_DESCRIPTION',
      iconKey: "receiptEuro"
    },
    addButtonText: 'TENANT.LABELS.ADD_INCOME',
    initialItem: {
      [IncomesFormFieldNames.IncomeType]: undefined,
      [IncomesFormFieldNames.Amount]: 0,
    }
  },
  ...addressInputsConfig
};
